import Puzzle from "./puzzle";


export default function PuzzleTestPage() {
    return <>
        <h1>TO JEST TYLKO TEST!</h1>
        <Puzzle onComplete={() => {}} />
    </>
}
